module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.shouldShowNavigation) ? _c('side-bar') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [(_vm.shouldShowNavigation) ? _c('nav-bar') : _vm._e(), _vm._v(" "), _c('router-view', {
    key: _vm.$route.fullPath
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-620f5005!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main.vue
// module id = 1015
// module chunks = 27